export default function test(str) {
    //if (!str) return false;
    if (str === "") return true;
    // regexp based check, allow only #abc and #aabbcc
    return /^#([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i.test(str);
}
